import { IOrderModel, IOrderRequest, OrderType } from 'models/Order';
import { getKeyByValue } from './enum';
import dayjs from 'dayjs';

export const mapOrder = (order: IOrderModel, urlSegments: string): IOrderRequest => {
  const orderTypeValue = urlSegments.charAt(0).toUpperCase() + urlSegments.slice(1);

  return {
    customerContact: order.customerContact,
    customerContactPhone: order.customerContactPhone,
    customerContactEmail: order.customerContactEmail,
    customerUnitId: Number(order.customerUnit.id),
    requestedName: order.requestedName,
    requestedPersonalNumber: order.requestedPersonalNumber,
    requestedPhone:
      order.requestedPhone !== null && order.requestedPhone.length > 0
        ? order.requestedPhone
        : null,
    requestedEmail:
      order.requestedEmail !== null && order.requestedEmail.length > 0
        ? order.requestedEmail
        : null,
    requestedHomeAddress:
      order.requestedHomeAddress !== null && order.requestedHomeAddress.length > 0
        ? order.requestedHomeAddress
        : null,
    requestedBriefDesc: order.requestedBriefDesc,
    requestedAdditionalInformation:
      order.requestedAdditionalInformation !== null &&
      order.requestedAdditionalInformation.length > 0
        ? order.requestedAdditionalInformation
        : null,
    requestedDate: order.requestedDate
      ? dayjs(order.requestedDate).format('YYYY-MM-DDTHH:mm:ss')
      : null,
    digitalDelivery: order.digitalDelivery === 'yes' ? true : false,
    smsConsent: order.smsConsent,
    feedbackPerformed: order.feedbackPerformed,
    feedbackRecipient:
      order.feedbackRecipient && order.feedbackRecipient.id === 'yes' ? true : false,
    feedbackContactDetails:
      order.feedbackContactDetails !== null && order.feedbackContactDetails.length > 0
        ? order.feedbackContactDetails
        : null,
    healthCenterId: Number(order.healthCenter.id),
    requestedNumberOfAttendees:
      orderTypeValue === 'Individual' ? 1 : order.requestedNumberOfAttendees,
    orderType: Number(getKeyByValue(OrderType, orderTypeValue)),
    additionalHealthCenters: order.additionalHealthCenters,
  };
};
